query TranslationEdit($id: ID!) {
  translation(id: $id) {
    id
    project
    namespace
    version
    variants {
      languageCode
      translated
      untranslated
      total
      words {
        key
        value
      }
    }
  }
}
